export const template1PlaceholderData = [
  {
    id: 1,
    name: 'Menu 1',
    categories: [
      {
        id: 1,
        name: 'burgers and sandwisches',
        items: [
          {
            id: 1,
            itemName: 'Chocolate Fudge',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
            modifiers: {},
            outOfStock: true,
          },
          {
            id: 2,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 3,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
            modifiers: {},
          },
          {
            id: 4,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
            modifiers: {},
          },
          {
            id: 5,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 6,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
          },
          {
            id: 7,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
          },
          {
            id: 8,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 9,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
          },
          {
            id: 10,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
          },
          {
            id: 11,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
        ],
      },
      {
        id: 2,
        name: 'Teas & More',
        items: [
          {
            id: 12,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
            modifiers: {},
          },
          {
            id: 13,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 14,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
          },
          {
            id: 15,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
          },
          {
            id: 16,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 17,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
          },
          {
            id: 18,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
          },
          {
            id: 19,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
          {
            id: 20,
            itemName: 'Churros',
            itemDescription: 'Crispy fried churros dusted with cinnamon sugar.',
            itemPrice: '3.49',
          },
          {
            id: 21,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription: 'Dense and rich brownie with a fudge center.',
            itemPrice: '3.99',
          },
          {
            id: 22,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '4.99',
          },
        ],
      },
      {
        id: 3,
        name: 'Snacks',
        items: [
          {
            id: 23,
            itemName: 'Margherita Pizza',
            itemDescription: 'Classic pizza with fresh mozzarella, tomatoes, basil, and a drizzle of olive oil.',
            itemPrice: '12.99',
            modifiers: {},
          },
          {
            id: 24,
            itemName: 'Pepperoni Blast',
            itemDescription: 'Loaded with pepperoni slices, mozzarella cheese, and a zesty tomato sauce.',
            itemPrice: '13.99',
          },
          {
            id: 25,
            itemName: 'Iced Latte',
            itemDescription: 'Espresso poured over ice and cold milk.',
            itemPrice: '2.49',
          },
          {
            id: 26,
            itemName: 'Iced Latte',
            itemDescription: 'Espresso poured over ice and cold milk.',
            itemPrice: '2.49',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Menu2',
    categories: [
      {
        id: 4,
        name: 'Cold Beverages',
        items: [
          {
            id: 27,
            itemName: 'Iced Latte',
            itemDescription: 'Espresso poured over ice and cold milk.',
            itemPrice: '2.49',
          },
          {
            id: 28,
            itemName: 'Iced Latte',
            itemDescription: 'Espresso poured over ice and cold milk.',
            itemPrice: '2.49',
            modifiers: {},
          },
        ],
      },
      {
        id: 5,
        name: 'Breakfast',
        items: [
          {
            id: 29,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
            modifiers: {},
          },
          {
            id: 30,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 31,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 32,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
            modifiers: {},
          },
          {
            id: 33,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 34,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 35,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 36,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 37,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 38,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 39,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 40,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 41,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 42,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 43,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 44,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 45,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 46,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 47,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
          {
            id: 48,
            itemName: 'Breakfast Burrito',
            itemDescription: 'Scrambled eggs, cheese, and veggies wrapped in a warm tortilla.',
            itemPrice: '6.50',
          },
        ],
      },
    ],
  },
];
